export const COMPACT_NUMBER_THRESHOLD = 1_000;

export function formatExactNumber(value: number): string {
  if (!Number.isFinite(value)) return "0";
  return Math.round(value).toLocaleString("en-US");
}

function trimDecimals(value: number, maxDecimals: number): string {
  const fixed = value.toFixed(maxDecimals);
  return fixed.replace(/\.0+$/, "").replace(/(\.\d*[1-9])0+$/, "$1");
}

function formatScaled(value: number, divisor: number, suffix: string, maxDecimals: number): string {
  return `${trimDecimals(value / divisor, maxDecimals)}${suffix}`;
}

/** Compact game-style number: 1500 → 1.5k, 100000 → 100k, 1000000 → 1M */
export function formatCompactNumber(value: number): string {
  if (!Number.isFinite(value)) return "0";

  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);

  if (abs < COMPACT_NUMBER_THRESHOLD) {
    return `${sign}${Math.round(abs)}`;
  }
  if (abs < 1_000_000) {
    return `${sign}${formatScaled(abs, 1_000, "k", 1)}`;
  }
  if (abs < 1_000_000_000) {
    return `${sign}${formatScaled(abs, 1_000_000, "M", 2)}`;
  }
  return `${sign}${formatScaled(abs, 1_000_000_000, "B", 2)}`;
}

export function formatDisplayNumber(value: number, mode: "compact" | "exact" = "compact"): string {
  if (mode === "exact") return formatExactNumber(value);
  if (Math.abs(value) < COMPACT_NUMBER_THRESHOLD) return formatExactNumber(value);
  return formatCompactNumber(value);
}

/** Tooltip text when compact form differs from the exact value. */
export function compactNumberTitle(value: number): string | undefined {
  const compact = formatDisplayNumber(value, "compact");
  const exact = formatExactNumber(value);
  return compact !== exact ? exact : undefined;
}
